const PageDescription = ({ children, className, ...rest }) => {
  return (
    <p className={`comp-page-description ${className}`} {...rest}>
      {children}
    </p>
  );
};

export default PageDescription;
